/**
 * @description Шлюз ОнБординга.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function OnBoardingGateway(axios) {
  /**
   * @description Обновить показанные представления пользователя.
   *
   * @param {string} showsSlugs
   *
   * @returns { string }
   */
  this.setShowToUser = async (showsSlugs) => {
    const params = {
      on_boarding_shows_slugs: showsSlugs,
    };
    const response = await axios
      .put(
        '/api/set-on-boarding-show',
        params,
      );
    return response.data;
  };
}
